/** Browsers have no scroll edge effect. */
export const isScrollEdgeEffectSupported: boolean = false;
